export default function ({ language }) {
  var config = {
    label: language['national-identity-label'],
    placeholder: language['national-identity-placeholder'],
    format: 'integer',
    maxLength: 11,
    validators: ['mandatory', 'numberOfDigits:11', 'nationalIdentity'],
  };

  return {
    config,
    extendsType: 'text-field',
  };
}
